
var id = "imgPreview";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"imgPreview\">\n<style type=\"text/css\">\n\t#imgPreview .st0{fill:#FFFFFF;}\n</style>\n<g id=\"imgPreview_商品管理V2\">\n\t<g id=\"imgPreview_编辑-商品类目-积分\" transform=\"translate(-379.000000, -304.000000)\">\n\t\t<g id=\"imgPreview_编组-8备份\" transform=\"translate(313.000000, 229.000000)\">\n\t\t\t<g id=\"imgPreview_编组-9\" transform=\"translate(0.000000, 10.000000)\">\n\t\t\t\t<g id=\"imgPreview_Group-3\" transform=\"translate(60.000000, 59.000000)\">\n\t\t\t\t\t<g id=\"imgPreview_Group-4\" transform=\"translate(6.000000, 6.000000)\">\n\t\t\t\t\t\t<path id=\"imgPreview_形状-copy\" class=\"st0\" d=\"M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0z M10,18\n\t\t\t\t\t\t\tc-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S14.4,18,10,18z\" />\n\t\t\t\t\t\t<path id=\"imgPreview_Shape\" class=\"st0\" d=\"M6,7C5.4,7,5,7.4,5,8s0.4,1,1,1c0.6,0,1-0.4,1-1C7,7.4,6.6,7,6,7z M4,14h12l-2.7-7L10,11.5\n\t\t\t\t\t\t\tL7.8,9.2L4,14z\" />\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
